<template>
  <div class="job-profile-preview-skeleton d-flex flex-column ga-4">
    <section class="job-profile-preview-skel-header d-flex flex-column align-center ga-2">
      <v-skeleton-loader
        type="heading"
        width="70%"
        class="job-profile-preview-skel-title"
      />
      <v-skeleton-loader
        type="text"
        width="80"
        height="24"
        class="job-profile-preview-skel-pill"
      />
      <v-skeleton-loader
        type="text"
        width="55%"
        class="job-profile-preview-skel-line"
      />
      <v-skeleton-loader
        type="text"
        width="40%"
        class="job-profile-preview-skel-line"
      />
    </section>

    <v-skeleton-loader
      type="button"
      width="100%"
      height="40"
      class="job-profile-preview-skel-btn"
    />

    <section
      v-for="i in fieldCount"
      :key="i"
      class="job-profile-preview-skel-field"
    >
      <v-divider
        v-if="i > 1"
        class="opacity-100 mt-3 mb-4"
      />
      <v-skeleton-loader
        type="text"
        width="35%"
        class="mb-2 job-profile-preview-skel-line"
      />
      <v-skeleton-loader
        type="text"
        width="100%"
        class="mb-1 job-profile-preview-skel-line"
      />
      <v-skeleton-loader
        type="text"
        :width="fieldBodyWidth(i)"
        class="job-profile-preview-skel-line"
      />
    </section>
  </div>
</template>

<script setup>
const fieldCount = 2;

const fieldBodyWidth = (index) => {
  const widths = ['92%', '78%'];

  return widths[index - 1] ?? '85%';
};
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader .v-skeleton-loader__heading),
:deep(.v-skeleton-loader .v-skeleton-loader__text) {
  background: @bg-canvas;
}

:deep(.v-skeleton-loader .v-skeleton-loader__button) {
  background: @bg-canvas;
}

.job-profile-preview-skel-title :deep(.v-skeleton-loader__heading) {
  height: 28px;
}

.job-profile-preview-skel-line :deep(.v-skeleton-loader__text) {
  height: 16px;
  border-radius: 6px;
}

.job-profile-preview-skel-pill :deep(.v-skeleton-loader__text) {
  height: 24px;
  border-radius: 24px;
}

.job-profile-preview-skel-btn :deep(.v-skeleton-loader__button) {
  height: 40px;
  border-radius: 8px;
  width: 100%;
}
</style>
